import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Zoom from '@material-ui/core/Zoom'
import {Dialog, DialogContent, DialogTitle, DialogActions, DialogContentText} from '@material-ui/core'
import {Checkbox, FormControlLabel} from '@material-ui/core'
import EmailDialog from '../components/EmailDialog'
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import ReactSpeedometer from 'react-d3-speedometer'

import { withStyles } from '@material-ui/core/styles';

import HeaderButtons from '../components/results/headerbuttons';

const styles = theme => ({
    root: {
        
    },
    header: {
        textAlign: 'center',
        marginBottom: '0px'
    },
    card: {
        padding: '0 1vw 1em 1vw'
    },
    center: {
        textAlign: 'center',
        justifyContent: 'center',
        transition: 'color .01s'
    }
});

class Landing extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoading:false,
            showTsCs:false,
            acceptsTCs:false,
            fontColor: "grey",
            segmentLabels:[],
            segmentBreakpoints:[]
        }
    }
    
    handleClick = () => {
        this.setState({
            isLoading: true
        })
        this.props.accept()
    }

    hideTCContent = () => {
        this.setState({
            showTsCs: false
        })
    }

    

    showTCContent = () => {
        this.setState({
            showTsCs: true
        })
    }

    acceptTCCheck = () => {
        this.setState({
            acceptsTCs: !this.state.acceptsTCs,
            fontColor: this.state.acceptsTCs ? "rgb(230, 0, 15)" : "rgb(230, 0, 15, 0.23)"
        })
    }

    render(){
        const {classes} = this.props
        let icon = null;
        if(this.state.isLoading){
            icon = <img src="loading.gif" width='20px' style={{marginLeft: '4px'}}/>
        } else {
            icon = <NavigateNextIcon id="next-icon"/>
        }

        //known issue in Material UI for newest version of Safari
        //Must change key when toggled to force a reload
        
        let disabled = !this.state.acceptsTCs
        return(
            <Card className={classes.card} raised="true" id="landing">
                <h2 className={classes.header}>{this.props.terms.HeaderFrame.Hook}</h2>
                <CardContent>
                    <p dangerouslySetInnerHTML={{__html: this.props.terms.HeaderFrame.About}}></p>
                    <div style={{textAlign:"center"}}>
                        <Button style={{fontStyle:"italic", textDecoration:"underline"}} onClick={() => this.showTCContent()}>
                            {this.props.terms.TCContent.ReadTermsContent}
                        </Button>
                        <br/>
                        <FormControlLabel
                            control={<Checkbox checked={this.state.acceptsTCs} onChange={this.acceptTCCheck} name="TCCheck" />}
                            label={this.props.terms.TCContent.AcceptCheckboxContent}
                        />
                    </div>

                </CardContent>
                <Dialog 
                    open={this.state.showTsCs}
                    TransitionComponent={Zoom}
                    keepMounted
                    onClose={() => this.hideTCContent()}>
                    <DialogTitle>{this.props.terms.TermsFrame.Header}</DialogTitle>
                    <DialogContent> 
                        <DialogContentText style={{wordWrap:"break-word"}} dangerouslySetInnerHTML={{__html: this.props.terms.TermsFrame.TermsAndConditions[0].StandardContent}}>
                            
                       </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => this.hideTCContent()}>{this.props.terms.TermsFrame.CloseButton}</Button>
                    </DialogActions>
                </Dialog>

                <CardActions className={classes.center}>
                <Button className={classes.center}
                        key={'${disabled}'} 
                        variant="contained"
                        color="primary"
                        disabled={disabled}
                        onClick={() => this.handleClick()}
                        >{this.props.terms.TCContent.StartAssessmentContent} {icon}</Button>
                </CardActions>
            </Card>
        )
    }
}

export default withStyles(styles)(Landing);